<template>
  <section class="login">
    <div class="login__header">
        <hero
      :image="hero"
      :show_logo="true"
    />

    </div>
    <div class="login__form-container">
      <Heading
        title="Welcome"
      />



      <FormWrapper @submit.native="handleSubmit">

        <p style="margin-bottom: 20px;">
          Welcome to the THIS HOSTEL App.
          You will need your reservation code to login
        </p>





        <InputContainer
          label="Confirmation number"
          type="email"
          :has-value="code"
        >
          <input
            v-model="code"
            :class="`input-field__input input-field__input--email`"
            placeholder="Your confirmation number"
            rules="required|"
            type="text"
          >
        </InputContainer>



        <Button
          title="Login"
          submit
          icon-right="arrow-right"
        />


      </FormWrapper>
    </div>
  </section>
</template>

<script>
import Button from '@/components/partials/Button.vue'
import Heading from '@/components/heading/Heading'
import FormWrapper from '@/components/form/FormWrapper.vue'
import InputContainer from '@/components/form/InputContainer.vue'
import Hero from '@/sections/section-header/SectionHeader'
import Chat from '@/components/partials/Chat'

export default {
  name: 'Login',
  components: {
    Button,
    FormWrapper,
    InputContainer,
    Heading,
    Hero,
    Chat
  },
  data () {
    return {
      code: '',
      hero: {
        url: '/img/thishostel/login-bg.png',
        alt: 'section-header Picture'
      },
    }
  },
  methods: {
    async handleSubmit () {
      console.log(this.code)
      await this.$store.dispatch('userprofile/requestLogin', { code: this.code })
      this.$router.replace({ name: 'auth.token-sent' })
    }
  },
  mounted () {
    window.$crisp.push(["do", "chat:hide"])
  }
}
</script>

<style lang="scss">
.login {
  display: flex;
  flex-direction: column;
  // position: relative;
  width: 100%;
  height: 100%;
  &__header {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  &__image {
    object-fit: $login-object-fit;
    width: $login-image-width;
    margin: auto 0 auto auto;
    height: 100%;
  }
  &__form-container {
    width: 100%;
    max-width: 600px;
    padding: $login-padding;
    background: $login-background;
  }
  .forgot {
    margin-top: 38px;
    padding-bottom: 40px;
    text-align: center;
    font-size: 0.875rem;
    letter-spacing: 0.11px;
    line-height: 1.25rem;
  }
}
</style>
